import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ContentState } from '@/store/content/types';

export const getters: GetterTree<ContentState, RootState> = {
  //
};
